import React from "react";
import {
  Chip as MuiChip,
  ChipProps as MuiChipProps,
  Tooltip,
} from "@mui/material";

export interface ChipProps extends MuiChipProps {
  label: React.ReactNode;
  tooltipTitle?: React.ReactNode;
  preset?: "primary" | "secondary" | "success" | "warning" | "error";
  sx?: MuiChipProps["sx"];
  size?: MuiChipProps["size"];
}

export const Chip: React.FC<ChipProps> = ({
  label,
  tooltipTitle,
  preset,
  sx,
  ...chipProps
}) => {
  const getPresetStyles = () => {
    switch (preset) {
      case "primary":
        return {};
      case "secondary":
        return { backgroundColor: "background.lightBlue" };
      case "success":
        return { backgroundColor: "background.success" };
      case "warning":
        return { backgroundColor: "background.warning" };
      case "error":
        return { backgroundColor: "background.error" };
      default:
        return {};
    }
  };

  const chipStyles = {
    ...getPresetStyles(),
    ...sx,
  };

  const chip = <MuiChip label={label} sx={chipStyles} {...chipProps} />;

  if (tooltipTitle) {
    return <Tooltip title={tooltipTitle}>{chip}</Tooltip>;
  }

  return chip;
};
